module.exports = __webpack_public_path__ + "static/media/gaurav2.95ea647f.jpeg";